import { Injectable } from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

@Injectable()
export class Formvalidator {

    formValidation: any;

    /**
     * Constructor
     */
    constructor() {
        this.setDefault();
    }    

    /**
     * Set default values
     */
    setDefault() {
        this.formValidation = {        
            birthPlaceError: false,
            professionError: false,
            phoneDaytimeError: false,
            reasonError: false,
            suaError: false
        }
    }

    validatePersonForm(personDetailsForm, suaCompanyForm, suaForm, modalData) {
        modalData[0] = "Valideringsfel";
        modalData[1] = "Vi kunde inte hitta vad som gick fel.";
        if (this.validateBirthPlace(personDetailsForm.birthplace, modalData)
                && this.validateEmployer(suaCompanyForm.selectedCompany, modalData)
                && this.validateReason(personDetailsForm.reasonText, modalData))
            {
                if(personDetailsForm.suaAssignment === 'true' && !this.validateSuaForm(suaForm.companySuaProject, modalData)) {
                    return false;
                }
                return true;
            }
        return false;
    }

    validateSuaForm(companySuaProject, modalData = ["", ""]) {
        if(companySuaProject === null) {
            modalData[0] = "Fel i fält: Namn på SUA Projekt/Uppdrag";
            modalData[1] = "Du har inte angivit något projekt eller uppdrag.";
            return false
        }
        return true;
    }

    validateBirthPlace(birthplace, modalData = ["", ""]) {    
        if (birthplace === null || birthplace.trim().length < 2) {
            this.formValidation.birthPlaceError = true;
            modalData[0] = "Fel i fält: Födelseort/Födelseland";
            modalData[1] = "Födelseort/Födelseland måste vara minst två bokstäver långt för att godkännas.";
        } else {
            this.formValidation.birthPlaceError = false; 
        }
        return !this.formValidation.birthPlaceError;
    }

    validateEmployer(employer, modalData = ["", ""]) {
        if (employer === null || employer === undefined || employer.trim().length < 2) {
            this.formValidation.employerError = true;
            modalData[0] = "Fel i fält: Arbetsgivare";
            modalData[1] = "Du har inte angivit någon arbetsgivare.";
        } else {
            this.formValidation.employerError = false;
        }
        return !this.formValidation.employerError;
    }

    validateReason(reason, modalData = ["", ""]) {
        if (reason === null || reason.trim().length < 2) {
            this.formValidation.reasonError = true;
            modalData[0] = "Fel i fält: Kontrollorsak";
            modalData[1] = "Kontrollorsak måste vara minst två karaktärer långt för att godkännas.";      
        } else {
            this.formValidation.reasonError = false;
        }
        return !this.formValidation.reasonError;
    }
}
